import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle, Microscope } from 'lucide-react';
export function OldSolutions() {
  const solutions = [{
    failed: 'Tés de sobre del supermercado',
    truth: 'Contienen menos del 2% de principio activo real. Es agua con aroma. No es medicina botánica — es marketing de bienestar.'
  }, {
    failed: 'Melatonina o pastillas para dormir',
    truth: 'Fuerzan el sueño pero no apagan el sistema nervioso. Resultado: te despiertas pesada, aturdida, y el ciclo reinicia exactamente igual.'
  }, {
    failed: '"Intentar no pensar"',
    truth: 'Neurológicamente imposible. El cerebro no puede obedecer una orden negativa sin recibir primero una señal física de seguridad.'
  }, {
    failed: 'Apps de meditación / respiración',
    truth: 'Poderosas a largo plazo. Inútiles cuando estás en colapso a las 11 PM y necesitas algo que actúe en minutos, no en meses.'
  }, {
    failed: 'Fuerza de voluntad',
    truth: 'No es un problema de actitud. Es un problema de señales químicas. La voluntad no puede apagar lo que la biología encendió.'
  }];
  return <section className="px-6 py-10 max-w-4xl mx-auto" data-id="element-132">
      <FadeIn data-id="element-133">
        <p className="text-lg md:text-xl text-center mb-8 text-[#2D2A26]" data-id="element-134">
          Antes de mostrarte qué funciona, hablemos honestamente de por qué todo
          lo anterior te ha fallado:
        </p>

        <div className="space-y-4" data-id="element-135">
          {solutions.map((item, index) => <div key={index} className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-[#4A5D3A]/10 flex flex-col md:flex-row gap-6 items-start" data-id="element-136">
              <div className="md:w-1/3 flex items-start gap-3" data-id="element-137">
                <XCircle className="text-[#9B4F2B] shrink-0 mt-1" size={24} data-id="element-138" />
                <h3 className="font-bold text-lg text-[#2D2A26]" data-id="element-139">
                  {item.failed}
                </h3>
              </div>
              <div className="md:w-2/3 flex items-start gap-3" data-id="element-140">
                <Microscope className="text-[#4A5D3A] shrink-0 mt-1" size={24} data-id="element-141" />
                <p className="text-[#2D2A26]/80 leading-relaxed" data-id="element-142">
                  {item.truth}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center space-y-3" data-id="element-143">
          <p className="text-2xl md:text-3xl font-serif font-bold text-[#9B4F2B]" data-id="element-144">
            El problema nunca fuiste tú.
          </p>
          <p className="text-xl md:text-2xl font-bold text-[#4A5D3A]" data-id="element-145">
            El problema es que nadie te dio el manual correcto.
          </p>
        </div>
      </FadeIn>
    </section>;
}